module.exports = __webpack_public_path__ + "static/media/TN-Women-Outerwears-2.0.f49788cf.svg";